"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isString2 = _interopRequireDefault(require("lodash/isString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_CSRF_SELECTOR = 'csrf-token';
var CSRF_METHODS = ['PATCH', 'POST', 'PUT', 'DELETE']; // Note: 'csrf' may be either:
// - A boolean indicating whether the token is needed (will use default selector to find it)
// - The name of the meta tag containing the token 

function getTokenFromDocument(csrf) {
  if (!document) return;
  var selector = (0, _isString2["default"])(csrf) ? csrf : DEFAULT_CSRF_SELECTOR;
  var meta = document.querySelector("meta[name=\"".concat(selector, "\"]"));
  if (meta && meta instanceof window.HTMLMetaElement) return meta.content;
} // Adds a CSRF token in a header if a 'csrf' option is provided


function includeCSRFToken(_ref) {
  var method = _ref.method,
      _ref$csrf = _ref.csrf,
      csrf = _ref$csrf === void 0 ? true : _ref$csrf,
      headers = _ref.headers;
  if (!csrf || !CSRF_METHODS.includes(method)) return;
  var token = getTokenFromDocument(csrf);
  if (!token) return;
  return {
    headers: _objectSpread({}, headers, {
      'X-CSRF-Token': token
    })
  };
}

var _default = includeCSRFToken;
exports["default"] = _default;